import * as actions from '../actions/actionTypes';
import initialState from './initialState';

/**
 * This reducer handles Authorization
 * @param {Object} [state] Authorization currently in the store
 * @param {Object} action The action to be handled
 * @returns {Object} Auth
 */
export default function authorizationsReducer(
  state = initialState.authorizations,
  action
) {
  switch (action.type) {
    case actions.LOAD_AUTHORIZATIONS_SUCCESS:
      return action.authorizations || [];
    case actions.LOAD_AUTHORIZATIONS_FAILURE:
      return initialState.authorizations; //??
    default:
      return state;
  }
}
